import { Link } from "@tanstack/react-router";
import { Building, LayoutDashboard, ScrollText } from "lucide-react";

export function Sidebar() {
  return (
    <aside className="w-64 min-w-64 border-r border-sidebar-border bg-sidebar min-h-screen">
      <div className="p-6">
        <nav className="space-y-1">
          <Link
            to="/dashboard"
            activeOptions={{ exact: true }}
            className="flex items-center text-sidebar-foreground gap-3 px-3 py-2 rounded-md text-sm font-medium transition-colors hover:bg-sidebar-accent hover:text-sidebar-accent-foreground [&.active]:bg-sidebar-primary [&.active]:text-sidebar-primary-foreground [&.active]:font-semibold"
          >
            <LayoutDashboard className="w-4 h-4" />
            Dashboard
          </Link>
          <Link
            to="/dashboard/clients"
            activeOptions={{ exact: true }}
            className="flex items-center text-sidebar-foreground gap-3 px-3 py-2 rounded-md text-sm font-medium transition-colors hover:bg-sidebar-accent hover:text-sidebar-accent-foreground [&.active]:bg-sidebar-primary [&.active]:text-sidebar-primary-foreground [&.active]:font-semibold"
          >
            <Building className="w-4 h-4" />
            Clients
          </Link>
          <Link
            to="/dashboard/audit-logs"
            activeOptions={{ exact: true }}
            className="flex items-center text-sidebar-foreground gap-3 px-3 py-2 rounded-md text-sm font-medium transition-colors hover:bg-sidebar-accent hover:text-sidebar-accent-foreground [&.active]:bg-sidebar-primary [&.active]:text-sidebar-primary-foreground [&.active]:font-semibold"
          >
            <ScrollText className="w-4 h-4" />
            Audit Log
          </Link>
        </nav>
      </div>
    </aside>
  );
}
